import React, { useRef } from 'react';
var VeltActivityLogListDateGroup = function (props) {
    var defaultCondition = props.defaultCondition, dateGroup = props.dateGroup, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-list-date-group", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "date-group": dateGroup }, children));
};
export default VeltActivityLogListDateGroup;
